/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiIndexType } from './InternalApiIndexType';
import {
    InternalApiIndexTypeFromJSON,
    InternalApiIndexTypeFromJSONTyped,
    InternalApiIndexTypeToJSON,
    InternalApiIndexTypeToJSONTyped,
} from './InternalApiIndexType';

/**
 * command to reindex an existing index in ES
 * @export
 * @interface InternalApiRecreateIndex
 */
export interface InternalApiRecreateIndex {
    /**
     * 
     * @type {InternalApiIndexType}
     * @memberof InternalApiRecreateIndex
     */
    type?: InternalApiIndexType;
    /**
     * 
     * @type {string}
     * @memberof InternalApiRecreateIndex
     */
    customList?: string;
}



/**
 * Check if a given object implements the InternalApiRecreateIndex interface.
 */
export function instanceOfInternalApiRecreateIndex(value: object): value is InternalApiRecreateIndex {
    return true;
}

export function InternalApiRecreateIndexFromJSON(json: any): InternalApiRecreateIndex {
    return InternalApiRecreateIndexFromJSONTyped(json, false);
}

export function InternalApiRecreateIndexFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiRecreateIndex {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : InternalApiIndexTypeFromJSON(json['type']),
        'customList': json['customList'] == null ? undefined : json['customList'],
    };
}

export function InternalApiRecreateIndexToJSON(json: any): InternalApiRecreateIndex {
    return InternalApiRecreateIndexToJSONTyped(json, false);
}

export function InternalApiRecreateIndexToJSONTyped(value?: InternalApiRecreateIndex | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': InternalApiIndexTypeToJSON(value['type']),
        'customList': value['customList'],
    };
}

